<template>
  <div id="testimonios">
    <!-- Título de Testimonios -->
    <h2 class="testimonios-title">Testimonios</h2>

    <div class="card-container1">
      <!-- Imagen a la izquierda en pantallas grandes, arriba en móviles -->
      <!-- <div class="image-container">
        <img src="@/assets/img/tablet.png" alt="Testimonios" />
        <v-btn
          rounded
          style="background-color: #a2c334"
          class="mt-2 white--text"
          large
          :href="'https://wa.me/+5214434846542?text=Estoy%20interesado%20en%20optimizar%20mi%20taller%20con%20OSD.'"
          target="_blank"
        >
          ¡Tambien quiero ser parte!
        </v-btn>
      </div> -->

      <!-- Cards a la derecha en escritorio, abajo en móviles -->
      <div class="card-container">
        <div class="card" v-for="(group, index) in featureGroups" :key="index">
          <div class="card-img-container">
            <img :src="group.gif" :alt="group.title" class="card-gif" />
          </div>
          <h3 class="card-title">{{ group.title }}</h3>
          <p class="card-description">{{ group.companyDescription }}</p>
          <v-btn
            rounded
            outlined
            large
            color="primary"
            dark
            @click="openDialog(group.idVideo)"
            target="_blank"
            class="mt-5"
          >
            Ver Video
          </v-btn>
          <p class="card-description">{{ group.empresa }}</p>
        </div>
      </div>
    </div>

    <!-- Dialogo para video -->
    <v-dialog
      v-model="dialog"
      max-width="75%"
      transition="dialog-bottom-transition"
    >
      <div
        style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          overflow: hidden;
          width: 100%;
        "
      >
        <iframe
          v-if="dialog"
          :src="`https://www.youtube.com/embed/${videoId}?autoplay=1`"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        ></iframe>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import Horacio from "@/assets/img/horacio.png";
import Ayala from "@/assets/img/ayala.png";
import { VDialog, VBtn } from "vuetify/lib"; // Asegúrate de que Vuetify esté correctamente importado

export default {
  name: "testimonios",
  components: {
    VDialog,
    VBtn,
  },
  data() {
    return {
      dialog: false, // Controla la visibilidad del diálogo
      videoId: "", // ID del video que se reproducirá
      featureGroups: [
        {
          gif: Horacio,
          title: "Testimonio Horacio",
          description:
            "Descubre cómo Horacio logró manejar sus tiempos y mejorar la eficiencia de su negocio.",
          companyDescription:
            "Multiacabados es una empresa de vanguardia dedicada al diseño y la fabricación de acabados de alta calidad. Horacio ha liderado esta compañía hacia el éxito al implementar una gestión de tiempo eficiente, lo que ha permitido optimizar su proceso de producción y mejorar su competitividad en el mercado.",
          idVideo: "2TFLevvXE7s", // ID del video de YouTube
          empresa: "Multiacabados",
        },
        {
          gif: Ayala,
          title: "Testimonio Ayala",
          description:
            "Escucha cómo Ayala optimizó su taller y logró resultados increíbles.",
          companyDescription:
            "Ayala Premium es una empresa especializada en el desarrollo de productos de alta gama. Ayala ha logrado posicionarse como líder en su sector mediante la innovación y el uso de tecnología avanzada, optimizando cada proceso y aumentando su rentabilidad.",
          idVideo: "ocPXHEbzJEs", // ID del video de YouTube
          empresa: "Ayala Premium",
        },
      ],
    };
  },
  methods: {
    openDialog(videoId) {
      this.videoId = videoId; // Asigna el ID del video al modelo
      this.dialog = true; // Abre el diálogo
    },
  },
};
</script>

<style scoped>
/* Estilo para el título de "Testimonios" */
.testimonios-title {
  text-transform: uppercase;
  font-size: 2rem;
  font-weight: bold;
  color: #9abe23; /* Verde */
  text-align: center;
  margin-bottom: 2rem;
}

.card-container1 {
  display: flex;
  width: 80%;
  margin: 0 auto;
  padding: 1rem;
}

/* Contenedor de la imagen en el lado izquierdo */
.image-container {
  width: 50%;
  display: flex;
  flex-direction: column; /* Cambia la dirección a columna */
  justify-content: center; /* Centra verticalmente */
  align-items: center; /* Centra horizontalmente */
  padding: 1rem;
  gap: 1rem; /* Espacio entre los ítems */
}

.image-container img {
  width: 100%;
  height: auto;
}

/* Contenedor de las tarjetas alineadas a la derecha */
.card-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 1rem;
  padding: 1rem;
}

.card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 1rem;
  transition: transform 0.3s ease;
}

.card-img-container {
  width: 120px;
  height: 120px;
  border-radius: 50%; /* Hace la imagen circular */
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-gif {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border: 2px solid #9abe23; /* Añadí un borde gris claro */
  border-radius: 50%; /* Asegura que la imagen quede completamente circular */
}

.card-title {
  font-size: 1.5rem; /* Aumenté el tamaño */
  font-weight: bold;
  margin: 0.5rem 0;
}

.card-description {
  font-size: 0.9rem; /* Aumenté el tamaño */
  color: #555;
}

.v-btn {
  margin-top: 1rem;
}

/* Estilo para la sección de Empresas */
.empresa-section {
  margin-top: 3rem;
  background-color: #f9f9f9;
  padding: 2rem;
}

.empresa-title {
  font-size: 2rem;
  font-weight: bold;
  color: #9abe23;
  text-align: center;
  margin-bottom: 1rem;
}

.empresa-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.empresa-name {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  color: #333;
}

.empresa-description {
  font-size: 1rem;
  text-align: justify;
  color: #555;
}

@media (max-width: 768px) {
  .card-container1 {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .image-container {
    width: 100%;
    margin-bottom: 1rem;
  }

  .image-container img {
    width: 60%;
  }

  .card-container {
    width: 100%;
    grid-template-columns: 1fr; /* Todas las cards en una sola columna en móviles */
  }
}
</style>
